export function fmtXOF(n) {
  const v = Number(n || 0);
  return new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(v) + " FCFA";
}

export function fmtNumber(n) {
  return new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Number(n || 0));
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
  } catch {
    return iso;
  }
}

export const PAIEMENT_STATUTS = {
  en_attente: { label: "En attente", cls: "pill-warning" },
  paye: { label: "Payé", cls: "pill-success" },
  partiel: { label: "Partiel", cls: "pill-info" },
  retard: { label: "Retard", cls: "pill-danger" },
  annule: { label: "Annulé", cls: "pill-neutral" },
  a_rapprocher: { label: "À rapprocher", cls: "pill-neutral" },
};

export const UNITE_STATUTS = {
  disponible: { label: "Disponible", cls: "pill-success" },
  reserve: { label: "Réservé", cls: "pill-warning" },
  loue: { label: "Loué", cls: "pill-info" },
  vendu: { label: "Vendu", cls: "pill-neutral" },
  travaux: { label: "En travaux", cls: "pill-danger" },
};

export const CONTRAT_STATUTS = {
  actif: { label: "Actif", cls: "pill-success" },
  termine: { label: "Terminé", cls: "pill-neutral" },
  resilie: { label: "Résilié", cls: "pill-danger" },
};

export const CONTRAT_TYPES = {
  vente: { label: "Vente classique", cls: "pill-info" },
  vefa: { label: "VEFA", cls: "pill-accent" },
  location_vente: { label: "Location-vente", cls: "pill-accent" },
  location: { label: "Location", cls: "pill-neutral" },
};

export const PROJET_STATUTS = {
  en_conception: { label: "En conception", cls: "pill-neutral" },
  en_construction: { label: "En construction", cls: "pill-warning" },
  livre_partiel: { label: "Livré partiellement", cls: "pill-info" },
  livre_complet: { label: "Livré complètement", cls: "pill-success" },
  commercialisation: { label: "Commercialisation", cls: "pill-accent" },
};

export const UNITE_CATEGORIES = {
  standard: { label: "Standard", cls: "pill-neutral" },
  confort: { label: "Confort", cls: "pill-info" },
  premium: { label: "Premium", cls: "pill-accent" },
};

export const CLIENT_STATUTS = {
  prospect: { label: "Prospect", cls: "pill-info" },
  actif: { label: "Actif", cls: "pill-success" },
  inactif: { label: "Inactif", cls: "pill-neutral" },
  resilie: { label: "Résilié", cls: "pill-danger" },
};

export const ROLE_LABELS = {
  admin: "Administrateur",
  secretaire: "Secrétaire",
  commercial: "Commercial",
  comptable: "Comptable",
  caissier: "Caissier",
  lecture: "Lecture seule",
};

// Moyen d'encaissement (comment) — distinct de la nature (ce que le paiement règle)
export const MODES_PAIEMENT = {
  especes: "Espèces",
  virement: "Virement",
  cheque: "Chèque",
  wave: "Wave",
  orange_money: "Orange Money",
  free_money: "Free Money",
  mobile_money: "Autre mobile money",
  carte: "Carte",
};

export const NATURES_ECHEANCE = {
  APPORT_INITIAL: "Apport initial",
  VERSEMENT_AVANCE: "Versement d'avance",
  MENSUALITE: "Mensualité",
  SOLDE_FINAL: "Solde final",
  FRAIS: "Frais",
  AUTRE: "Autre",
};

// Natures proposées à la caisse (Avance/Acompte regroupe APPORT_INITIAL + VERSEMENT_AVANCE)
export const NATURES_ENCAISSEMENT = {
  VERSEMENT_AVANCE: "Avance / Acompte",
  MENSUALITE: "Mensualité",
  FRAIS: "Frais",
  SOLDE_FINAL: "Solde final",
  AUTRE: "Autre",
};

export async function downloadPdf(api, url, filename) {
  let res;
  try {
    res = await api.get(url, { responseType: "blob" });
  } catch (e) {
    // Les refus métier (409 « ligne à rapprocher », « déjà encaissée »…) arrivent en blob : on affiche le message
    let msg = "Téléchargement impossible";
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch (_) { /* message par défaut */ }
    const { toast } = await import("sonner");
    toast.error(msg, { duration: 9000 });
    return;
  }
  const cd = res.headers?.["content-disposition"] || "";
  const m = cd.match(/filename\*?=(?:utf-8'')?"?([^";]+)"?/i);
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = m ? decodeURIComponent(m[1]) : filename;
  a.click();
  URL.revokeObjectURL(href);
}
